module.exports = __webpack_public_path__ + "img/3.3df7b9cb.png";